// Date Functions
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import isBetween from "dayjs/plugin/isBetween";
import minMax from "dayjs/plugin/minMax";
dayjs.extend(customParseFormat);
dayjs.extend(isBetween);
dayjs.extend(minMax);

export const openSidebar = () => {
  if (typeof document !== "undefined") {
    document.body.style.overflow = "hidden";
    document.documentElement.style.setProperty("--SideNavigation-slideIn", "1");
  }
};

export const closeSidebar = () => {
  if (typeof document !== "undefined") {
    document.documentElement.style.removeProperty("--SideNavigation-slideIn");
    document.body.style.removeProperty("overflow");
  }
};

export const toggleSidebar = () => {
  if (typeof window !== "undefined" && typeof document !== "undefined") {
    const slideIn = window
      .getComputedStyle(document.documentElement)
      .getPropertyValue("--SideNavigation-slideIn");
    if (slideIn) {
      closeSidebar();
    } else {
      openSidebar();
    }
  }
};

export const currencyFormatter = (currencyCode, value) => {
  // let amount = 0;
  // if (value) {
  //   amount = Number(value?.replaceAll(",", ""));
  // } else {
  //   amount = Number(value);
  // }
  const amount = Number(value);
  switch (currencyCode) {
    case "EUR":
      return new Intl.NumberFormat("en-GB", {
        style: "currency",
        currency: "EUR",
      }).format(amount);
    case "USD":
      return new Intl.NumberFormat("en-GB", {
        style: "currency",
        currency: "USD",
      }).format(amount);
    default:
      return new Intl.NumberFormat("en-GB", {
        style: "currency",
        currency: "GBP",
      }).format(amount);
  }
};

// // Clean JSON from Portal API
// export const unescapeJSON = (escapedJSON) => {
//   const sliceOut = escapedJSON.slice(1, -1);
//   return JSON.parse(sliceOut);
// };

// Capitalise the first letter of a Word
export const sentenceCase = (word) =>
  word.charAt(0).toUpperCase() + word.slice(1);

// Calculate latest date from the shipment lines
export const getLatestDate = (shipmentLines) => {
  const dayjsDateArray = [];
  shipmentLines?.map((date) => {
    dayjsDateArray.push(dayjs(date.sla_date, "DD/MM/YY"));
  });
  if (dayjsDateArray.length > 0) {
    return dayjs.max(dayjsDateArray).format("DD/MM/YY");
  }
};

// Create Order Save Object
export const createOrderSaveObj = (
  orderNo,
  poNo,
  estDespatchDate,
  shippingAgent,
  shippingService,
  outOfSLA,
  sequence,
  orderLines,
) => {
  const filter = { noFilter: orderNo };
  const header = {
    no: orderNo,
    poNo: poNo,
    requestedShippingDate: dayjs(estDespatchDate, "DD/MM/YY").format(
      "MM/DD/YY",
    ),
    shippingAgentCode: shippingAgent,
    shippingChargeCode: shippingService,
    outOfSLA: outOfSLA,
    seq: sequence,
  };

  const lines = [];
  orderLines.map((line) => {
    const orderLine = {
      documentNo: orderNo,
      lineNo: line.lineNo,
      staffLineNo: line.staffLineNo,
      itemNo: line.itemNo,
      quantity: line.quantity,
    };
    lines.push(orderLine);
  });

  const order = {
    filter: filter,
    header: header,
    lines: lines,
  };

  return order;
};

// Function to return a filter string for the user branches
// Will return a string with a pipe separator if more than one e.g. "B001|Z004" or "A003"
export const branchFilterString = (userBranches) => {
  let userBranchFilter = "";
  userBranches?.map((branch, index) => {
    const last = index === userBranches.length - 1;

    return last
      ? (userBranchFilter += branch.branchId)
      : (userBranchFilter += `${branch.branchId}|`);
  });
};
